export enum EventTypes {
  BUTTON = 'Button',
  ENGAGEMENT = 'Engagement',
}
